
export default function getFormError(name: string, errors: { [name: string]: any }) {
  // console.log("errors[name]", errors[name])
  return Array.isArray(errors[name])
    ? errors[name].join(", ")
    : errors[name]?.message || errors[name]
}
